import script from "./MenuLateralComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLateralComponents.vue?vue&type=script&setup=true&lang=js"

import "./MenuLateralComponents.vue?vue&type=style&index=0&id=4575828a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4575828a"]])

export default __exports__